import axiosInstance from "./AxiosInstance";
import { loginConfirmedAction, Logout } from "../store/actions/AuthActions";

function me(token) {
  return axiosInstance.get(`/me`, {
    Authorization: `Bearer ${token}`,
  });
}

export function login(email, password) {
  const postData = {
    email,
    password,
  };
  return axiosInstance.post(`/login`, postData);
}

export function saveTokenInLocalStorage(tokenDetails) {
  tokenDetails.expireDate = new Date(
    new Date().getTime() + tokenDetails.expiresIn * 1000
  ).toString();
  localStorage.setItem("userDetails", JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, navigate) {
  setTimeout(() => {
    //dispatch(Logout(history));
    dispatch(Logout(navigate));
  }, timer);
}

export async function checkAutoLogin(dispatch, navigate) {
  const tokenDetailsString = localStorage.getItem("userDetails");

  let tokenDetails = "";
  if (!tokenDetailsString) {
    dispatch(Logout(navigate));
    return;
  }

  tokenDetails = JSON.parse(tokenDetailsString);
  let expireDate = new Date(tokenDetails.expireDate);
  let todaysDate = new Date();

  if (todaysDate > expireDate) {
    dispatch(Logout(navigate));
    return;
  }
  // try {
  //   me(tokenDetails.token);
  // } catch (e) {
  //   dispatch(Logout(navigate));
  //   return;
  // }

  dispatch(loginConfirmedAction(tokenDetails));

  const timer = expireDate.getTime() - todaysDate.getTime();
  runLogoutTimer(dispatch, timer, navigate);
}
